<template>
    <div>
        <div class="card card-default" style="border: 0;">
            <div class="card-body">
                <form role="form" @submit.prevent>
                    <input type="text" id="kiosk-users-search" class="form-control"
                            name="search"
                            placeholder="Search by Name..."
                            v-model="searchForm.query"
                            @keyup.enter="search">
                </form>
            </div>
        </div>

        <div class="card card-default" v-if="searching">
            <div class="card-header">Search Results</div>

            <div class="card-body">
                <i class="fa fa-btn fa-spinner fa-spin"></i> Searching
            </div>
        </div>

        <div class="card card-default" v-if="!searching && noSearchResults">
            <div class="card-header">Search Results</div>

            <div class="card-body">
                No users matched the given criteria.
            </div>
        </div>

        <div class="card card-default" v-if="!searching && searchResults.length > 0">
            <div class="card-header">Search Results</div>

            <div class="table-responsive">
                <table class="table table-valign-middle mb-0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>E-Mail Address</th>
                            <th>Contact Amount</th>
                            <th class="th-fit"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="company in searchResults">
                            <td>
                                {{company.name}}
                            </td>

                            <td>
                                {{company.email}}
                            </td>

                            <td>
                                {{company.contact_amount}}
                            </td>

                            <td>
                                <a :href="'/company/' + company.id" class="btn btn-default">
                                    <i class="fa fa-search"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'companies',

        data: () => ({
            searching: false,
            noSearchResults: false,
            searchResults: [],
            searchForm: new SparkForm({
                query: ''
            })
        }),

        computed: {
            user() {
                return this.$root.user;
            }
        },

        methods: {
            search() {
                this.searching = true;
                this.noSearchResults = false;

                axios.post(route('spark.kiosk.company.search'), this.searchForm)
                    .then(response => {
                        this.searchResults = response.data.data;
                        this.noSearchResults = this.searchResults.length === 0;

                        this.searching = false;
                    });
            }
        }
    }
</script>
